import { ApiError } from '../../../api/client';

// PARA-135 (C-3, AC-E3a) — распознавание отказа «понижение размера у задачи с
// подзадачами» (CannotDowngradeTaskWithSubtasksError → 409).
// `JSON.parse(error.message)` запрещён — по образцу соседнего lib/quotaError.ts.
// Отдельный модуль, а не расширение quotaError.ts: тот про квоту 402.

/** PATCH /tasks/{id} отклонён из-за подзадач (409), а не из-за чего-то ещё. */
export function isSizeDowngradeConflict(error: unknown): boolean {
  return error instanceof ApiError && error.status === 409;
}

// PARA-135 (H-2, AC-E3) — задача удалена в другой сессии. Нужен обоим путям:
// экрану правки и пути тапа по карточке (смена статуса), где до этого на любую
// ошибку показывалось общее «не удалось сменить статус».
/** Задача не найдена или принадлежит другому пользователю (404). */
export function isTaskNotFound(error: unknown): boolean {
  return error instanceof ApiError && error.status === 404;
}
